module.exports = "/legacy/24bafe13eeb8216b230382deb5896397.svg";